import { mapActions, mapGetters, mapMutations } from "vuex";
import {
    ACTIVATION_EMAIL
} from '@/store/action-types';
import {
    SET_TOKEN
} from "@/store/mutation-types";

export default {
    name: 'activation-email',
    breadcrumb() {
        return {
            label: this.$t('activationEmail'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                }
            ]
        }
    },
    data(){
      return{
          payload: {}
      }
    },

    computed: {
        ...mapGetters({

        }),
    },

    created() {
        this.payload = {
            activation_code: this.$route.query.activation_code,
            email: this.$route.query.email
        }

        if (Object.keys(this.$route.query).length > 0 &&
            this.payload.activation_code !== '' &&
            this.payload.email !== '') {
            this.submitActivationEmail();
        }
    },

    methods: {
        ...mapActions({
            activateEmail: `auth/${ACTIVATION_EMAIL}`
        }),

        ...mapMutations({
            setToken: `auth/${SET_TOKEN}`
        }),

        navigateToSingIn() {
            this.$router.push({name: 'sing-in'});
        },

        navigateToHome() {
            this.$router.push({name: 'home'});
        },

        submitActivationEmail() {
            this.activateEmail(this.payload)
                .then((payload) => {
                    this.setToken(payload)

                    this.$toasted.success(this.$t('successAuth')).goAway(5000);
                    this.$router.push({name: 'home'});
                }).catch(error => {
                if (error.response.status === 422) {
                    this.$toasted.error(error.response.data.message).goAway(5000);
                }
            });
        }
    }
}
